import React, { Component } from "react";

import "./styles.css";

class QuestionSelectorMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      class: {
        wrapper: "question-type-selector-menu-wrapper",
        header: "question-type-selector-menu-header"
      },
      // selection: null,
      title: this.props.items.find(item => item.id === this.props.currentTypeId)
        ?.name
    };
  }

  handleToggle() {
    this.setState(prevState => ({ open: !prevState.open }));
  }

  handleClick(item) {
    this.setState({
      // selection: item.id,
      title: item.name,
      open: false
    });

    this.props.typeSelector(item.id);
  }

  render() {
    return (
      <>
        {this.props.readOnly ? (
          <div className={this.state.class.wrapper}>
            <div tabIndex={0} className={this.state.class.header}>
              <div className="question-type-selector-header-title">
                <p className="teste">{this.state.title}</p>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={
              this.state.open
                ? `${this.state.class.wrapper}-active`
                : this.state.class.wrapper
            }
          >
            <div
              tabIndex={0}
              className={
                this.state.open
                  ? `${this.state.class.header}-active`
                  : this.state.class.header
              }
              role="button"
              onKeyPress={() => this.handleToggle()}
              onClick={() => this.handleToggle()}
            >
              <div className="question-type-selector-header-icon mr-2">
                <i
                  className={`m-0 fa fa-chevron-${
                    this.state.open ? "down" : "right"
                  }`}
                ></i>
              </div>
              <h6 className="m-0">{this.state.title}</h6>
            </div>
            {this.state.open && (
              <ul className="question-type-selector-list">
                {this.props.items.map(item => (
                  <li
                    className="question-type-selector-list-item"
                    key={item.id}
                  >
                    <button
                      type="button"
                      onClick={() => this.handleClick(item)}
                    >
                      <span>{item.name}</span>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </>
    );
  }
}

export default QuestionSelectorMenu;
